import {PiBlueprint, PiCertificate} from "react-icons/pi";
import Button from "@/components/ui/Button";
import {
  PublicAssetFrontendApi$AssetComponentDto,
  PublicAssetFrontendApi$AssetComponentDtoKey,
} from "@/custolink-transpiled_by_server/bc.asset_interaction.api_methods";
import { ReactNode } from "react";
import {GiPapers, GiVideoConference} from "react-icons/gi";
import {FaHelmetSafety} from "react-icons/fa6";
import { GrBusinessService } from "react-icons/gr";
import { TbArrowGuide } from "react-icons/tb";

export default function MiddleSection(p: {
  components: Array<PublicAssetFrontendApi$AssetComponentDto>;
  selectComponentToShow: (c: PublicAssetFrontendApi$AssetComponentDto) => void;
}) {
  let grid = "grid-cols-3"
  if(p.components.length == 2 || p.components.length == 4) {
    // Special case: when there are 2 or 4 components, then 2 by 2 looks better
    grid = "grid-cols-2"
  }
  return (
    <>
      <div className={"grid gap-4 mx-auto " + grid}>
        {p.components.map((m) => {

          return (
            <div key={m.key}
              className={
                "flex-1 flex flex-col justify-center items-center space-y-1"
              }
            >
              <Button
                className={"shadow-xl"}
                shape="round"
                size="lg"
                variant={"default"}
                icon={toIcon(m.key)}
                onClick={()=>{
                  p.selectComponentToShow(m)
                }}
              />
              <div className={"text-xs text-center whitespace-nowrap w-full"}>
                {m.name}
              </div>
            </div>
          );
        })}

      </div>
    </>
  );
}

function toIcon(
  key: PublicAssetFrontendApi$AssetComponentDtoKey,
): ReactNode {
  switch (key) {
    case PublicAssetFrontendApi$AssetComponentDtoKey.Inquiry:
      return <GrBusinessService />;
    case PublicAssetFrontendApi$AssetComponentDtoKey.Certificates:
      return <PiCertificate />;
    case PublicAssetFrontendApi$AssetComponentDtoKey.Drawings:
      return <PiBlueprint />;
    case PublicAssetFrontendApi$AssetComponentDtoKey.Manuals:
      return <GiPapers />;
    case PublicAssetFrontendApi$AssetComponentDtoKey.SafetyVideos:
      return <FaHelmetSafety />;
    case PublicAssetFrontendApi$AssetComponentDtoKey.TrainingVideos:
      return <GiVideoConference />
    case PublicAssetFrontendApi$AssetComponentDtoKey.QuickStartGuides:
      return <TbArrowGuide />
  }
  return <></>
}
